export default "__VITE_ASSET__ZNcL0ZhV__"